import { render } from "./OfferInformation.vue?vue&type=template&id=cb5f773e&scoped=true"
import script from "./OfferInformation.vue?vue&type=script&lang=js"
export * from "./OfferInformation.vue?vue&type=script&lang=js"

import "./OfferInformation.vue?vue&type=style&index=0&id=cb5f773e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb5f773e"]])

export default __exports__